import { FormEvent, useEffect, useRef, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import classes from './Header.module.css';

interface HeaderSearchBarProps {
  placeholder?: string;
  className?: string;
}

export const HeaderSearchBar = ({ placeholder = 'Search...', className }: HeaderSearchBarProps) => {
  const inputRef = useRef<HTMLInputElement>(null);
  const [error, setError] = useState(false);
  const [searchParams, _setSearchParams] = useSearchParams();
  const navigate = useNavigate();
  const term = searchParams.get('searchTerm') || '';

  useEffect(() => {
    if (inputRef.current && term !== inputRef.current.value) {
      inputRef.current.value = term;
    }
  }, [term]);

  const handleSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const text = inputRef.current?.value ?? '';
    setError(text.length > 0 && text.length < 3);
    if (text.length < 3) return;
    navigate(`/website/search?searchTerm=${encodeURIComponent(text)}`);
  };

  return (
    <form className={`${classes.searchForm}${className ? ` ${className}` : ''}`} onSubmit={handleSubmit}>
      <span className={classes.searchIcon} aria-hidden>
        🔍
      </span>
      <input
        name="search"
        ref={inputRef}
        type="text"
        autoComplete="off"
        placeholder={placeholder}
        className={`${classes.searchInput}${error ? ` ${classes.searchInputError}` : ''}`}
      />
    </form>
  );
};
